import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import EduStats from "../../components/eduStats/EduStats";
import PageHero from "../../components/pageHero/PageHero";
import Educations from "../../containers/education/Educations";
import Certifications from "../../containers/certifications/Certifications";
import CompetitiveSites from "../../components/competitiveSites/CompetitiveSites";
import { competitiveSites } from "../../portfolio";
import "./EducationComponent.css";

class Education extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="education-main">
        <Header theme={theme} />
        <PageHero
          kicker="Education"
          title="Qualifications & certifications"
          description="Formal education and the courses and bootcamps behind my engineering practice."
        >
          <CompetitiveSites logos={competitiveSites.competitiveSites} />
        </PageHero>
        <div className="page-wrap">
          <EduStats />
          <Educations theme={theme} />
          <Certifications theme={theme} />
        </div>
        <Footer theme={theme} />
        <TopButton theme={theme} />
      </div>
    );
  }
}

export default Education;
